import(/* webpackMode: "eager" */ "/Users/z/work/lux/web/app/quest/src/app/page.tsx");
